module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10199.4689eec9.jpg";